import React, { Component } from 'react';
import './styles.scss';
import { connect } from 'react-redux';
import { Field } from 'redux-form';
import { Box, HorizontalFormControl } from '../../../../../../common/components';
import { Col, FormGroup } from 'react-bootstrap';
import { actions as postcodeActions } from '../../../../../../common/components/Postcode/redux/PostcodeActions';
import BrokerBusinessType from './components/BrokerBusinessType';
import { bindActionCreators } from 'redux';
import { SelectField } from '../../../../../../common/components/ReduxFormField';

class General extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { postcodeActions } = this.props;
    postcodeActions.clearSelection();
  }

  render() {
    const { content } = this.props;
    return (
      <Box>
        <FormGroup>
          <Col sm={12}>
            <h4 className="page-title">General Information</h4>
          </Col>
        </FormGroup>

        <Field
          name={'data.attributes.reference'}
          component={HorizontalFormControl}
          label={'Reference'}
          labelSize={3}
        />

        <Field
          name={'data.attributes.metadata.broker_channel'}
          component={SelectField}
          label={'Channel'}
          options={[
            { label: 'Annevo', value: 'jtc-brokers' },
            { label: 'JTC', value: 'jtc-b2b' },
          ]}
          labelSize={3}
        />

        {content.fields.map((field) => {
          switch (field.type) {
            case 'radio': {
              if (field.selectType === 'brokerBusinessType') {
                return (
                  <Field
                    name={field.name}
                    key={field.name}
                    component={BrokerBusinessType}
                    options={field.options}
                  />
                );
              }
              break;
            }
            case 'input': {
              return (
                <Field
                  name={field.name}
                  key={field.name}
                  labelSize={3}
                  fieldSize={9}
                  component={HorizontalFormControl}
                  label={field.label}
                />
              );
            }
          }
        })}
      </Box>
    );
  }
}

export default connect(
  () => {
    return {
      destroyOnUnmount: false,
      forceUnregisterOnUnmount: true,
    };
  },
  (dispatch) => ({
    postcodeActions: bindActionCreators(postcodeActions, dispatch),
    dispatch,
  }),
)(General);
